/* Publish by EComposer at 2026-10-26 04:30:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k800ebgm2xb"]=  window.__ectimmers["ecom-k800ebgm2xb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-k800ebgm2xb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k800ebgm2xb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nihepag7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nihepag7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfw2d6gsgof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfw2d6gsgof', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qk28mmt3uf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qk28mmt3uf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jatyqpvi7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jatyqpvi7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9jy3obloaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9jy3obloaj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mho98sv02').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mho98sv02', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dmming6z8mg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dmming6z8mg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v18goemdlea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v18goemdlea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bi6jyphtwdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bi6jyphtwdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9n74jrlis9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9n74jrlis9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpjtxz2nhjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpjtxz2nhjc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y44wuhznc2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y44wuhznc2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-393qiugk9yk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-393qiugk9yk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0g3x31w6rzv5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g3x31w6rzv5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9de8d8rwwji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9de8d8rwwji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1hzre9upkx3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1hzre9upkx3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4i344pkgpqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4i344pkgpqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcn9sr70v2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcn9sr70v2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lyw92z18258').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lyw92z18258', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ms5ok44fjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ms5ok44fjc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8992sd5yua9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8992sd5yua9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf5cpmbx3q9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf5cpmbx3q9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mci6rv2w4i7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mci6rv2w4i7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dj69va9mym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dj69va9mym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jgn6uxhljj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jgn6uxhljj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yumwmu4mqbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yumwmu4mqbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yh7kjmaljmg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yh7kjmaljmg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xc7otp1h4sb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xc7otp1h4sb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ysmxzdn1hg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ysmxzdn1hg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hpm4n69wc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hpm4n69wc4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8w4besa6pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8w4besa6pl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2d6czhj9pc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2d6czhj9pc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3f93b1gub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3f93b1gub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37w23sh0pjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37w23sh0pjk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wq77zmdr3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wq77zmdr3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esbohofxy04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esbohofxy04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3n7x44rhki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3n7x44rhki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9x4urilnywb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9x4urilnywb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rz3tnq6rd8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rz3tnq6rd8e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4r3w6afecm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4r3w6afecm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z039usopkrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z039usopkrk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbbc6ngmlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbbc6ngmlo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6f4le17ymcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6f4le17ymcf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckpc8b3ipnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckpc8b3ipnf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g0p9pwwolwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g0p9pwwolwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xroibmsr32').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xroibmsr32', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-stre5wlavbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-stre5wlavbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bycg3vlgndc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bycg3vlgndc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysmgurm1fwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysmgurm1fwo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-myqyz28rxmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-myqyz28rxmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfz43j3uedm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfz43j3uedm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-th8rqwrp04s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-th8rqwrp04s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jbwmhrhpcam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jbwmhrhpcam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7tp7j446n8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7tp7j446n8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p98wc8wjco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p98wc8wjco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ms7k0wkpfsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ms7k0wkpfsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ksvy32ce3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ksvy32ce3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oouq4mlb9km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oouq4mlb9km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fm2f603c9ap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fm2f603c9ap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lncahrkssdi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lncahrkssdi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k422sgfmvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k422sgfmvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-munf2nqb98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-munf2nqb98', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sc7infyx58d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sc7infyx58d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ailyatoy9yf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ailyatoy9yf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0rz5dkuuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0rz5dkuuw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r016tp92b8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r016tp92b8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9d6ahllq1hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9d6ahllq1hj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wps71uiwfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wps71uiwfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bj8a4yibgjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bj8a4yibgjj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ft1w1beob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ft1w1beob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ehsqvj76s1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehsqvj76s1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9squ5u9zr5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9squ5u9zr5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebxwhe1spm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebxwhe1spm8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7gd8f05je6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7gd8f05je6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tau5ugu2k4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tau5ugu2k4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y43ro8ry2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y43ro8ry2v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7s937hn24q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7s937hn24q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbs7wp2bnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbs7wp2bnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86ppdbms4ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86ppdbms4ob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19mzzxu0jkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19mzzxu0jkg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ep6m822o2nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ep6m822o2nq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqcm03scgbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqcm03scgbs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2gtvfdo3rvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2gtvfdo3rvo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3ivbptxh4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3ivbptxh4c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sc6bhpntl0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sc6bhpntl0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-efwtxsdks0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-efwtxsdks0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-btfvlvjpcrb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btfvlvjpcrb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lhopcf8nu2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lhopcf8nu2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lm3penycgem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm3penycgem', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nwxxpcjple').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nwxxpcjple', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l125y4t3ar9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l125y4t3ar9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9rpszbcgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9rpszbcgg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9q88u4fsnu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9q88u4fsnu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5ztetwzii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5ztetwzii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lim40lk6tcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lim40lk6tcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7pagmqkyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7pagmqkyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wrp8jv11n3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wrp8jv11n3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yd6bai0xg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yd6bai0xg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2oimn5zmdgq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2oimn5zmdgq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2605vhu7euf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2605vhu7euf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idziwmw4lu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idziwmw4lu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02mm4skgoqbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02mm4skgoqbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lx5a649wvrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lx5a649wvrg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rhonm1pvq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rhonm1pvq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62ol94vsspk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62ol94vsspk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gr6q7vpbqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gr6q7vpbqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmv9ozq3wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmv9ozq3wa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xq4ainhhwb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xq4ainhhwb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-osqeoqn36c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osqeoqn36c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f6ii29n0pg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6ii29n0pg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-539x79wbk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-539x79wbk4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5vd0gh428a6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5vd0gh428a6', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ej4wk5v8j86"]=  window.__ectimmers["ecom-ej4wk5v8j86"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ej4wk5v8j86"]["h0p38pxty"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ej4wk5v8j86').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ej4wk5v8j86', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xk6pg2fk898').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk6pg2fk898', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9cuks61wuti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cuks61wuti', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lxzqngkkewb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lxzqngkkewb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3w3jkj9qo03').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3w3jkj9qo03', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r58g9dobdr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r58g9dobdr9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rmxbxmbjn2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rmxbxmbjn2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yeb4fy2lxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yeb4fy2lxu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cb000ez4bvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cb000ez4bvh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k19kdx1i5nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k19kdx1i5nr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fot7wonrb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fot7wonrb5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ds8f9xb2lg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ds8f9xb2lg9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbqe7llvci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbqe7llvci', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hazy7qmsmnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hazy7qmsmnb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wep1opgio6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wep1opgio6q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjdfsdss4f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjdfsdss4f8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf7iafw33nh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf7iafw33nh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cunhz80p9tk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cunhz80p9tk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5l0wlqn057x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5l0wlqn057x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0yhcmro2kp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0yhcmro2kp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3z2r0yl3hh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3z2r0yl3hh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hlan0lobxpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hlan0lobxpo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cdp15lsnusn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cdp15lsnusn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3erfa0np4t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3erfa0np4t5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sslih1s0u7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sslih1s0u7m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-je3iiwpo2re').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-je3iiwpo2re', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11uzb36xftf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11uzb36xftf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r49xoh5kvgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r49xoh5kvgs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxd1bt2y61e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxd1bt2y61e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iinjk46ba8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iinjk46ba8r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dxfxqmjuc8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dxfxqmjuc8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0up9tvjhnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0up9tvjhnf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9itx3na2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9itx3na2a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8bnn02n60lj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8bnn02n60lj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxzk9cj6lh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxzk9cj6lh9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ifrb3oxt9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ifrb3oxt9h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-isrr5t7v9vc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-isrr5t7v9vc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zaffwtgqksn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zaffwtgqksn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-argjq7i0ujp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-argjq7i0ujp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1i9qzxp2a8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1i9qzxp2a8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yfep5odwh1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfep5odwh1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cck1vyyuwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cck1vyyuwl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjf0ixavsba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjf0ixavsba', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4q7qhy2qrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4q7qhy2qrg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mhlwpkhfnn"]=  window.__ectimmers["ecom-mhlwpkhfnn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-mhlwpkhfnn"]["e326ru545"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-mhlwpkhfnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhlwpkhfnn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x9wynmfpos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x9wynmfpos', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjbo0a8hzyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjbo0a8hzyn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6g6k664berp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6g6k664berp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-os9xy8mzr0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-os9xy8mzr0q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkwsu3fvnsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkwsu3fvnsd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izoojmbjsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izoojmbjsk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uzdz9s1ggf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uzdz9s1ggf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yv3jj9mplz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yv3jj9mplz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbvvf89gll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbvvf89gll', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xj2wzyjshwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xj2wzyjshwd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v06frzfhfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v06frzfhfe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e34tyd3ex8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e34tyd3ex8c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ex67cn0iqu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ex67cn0iqu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8jfcyn6ct8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8jfcyn6ct8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3f5qvzex3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3f5qvzex3d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97q8d5o7css').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97q8d5o7css', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xfqtdw4ho2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xfqtdw4ho2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qh9gapsht4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qh9gapsht4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0lt4rr5sdv8a"]=  window.__ectimmers["ecom-0lt4rr5sdv8a"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,s=this.settings.autoplay,o=this.settings.lazyload||!1,n=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(I){let D={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,D).observe(I)}function y(I,D){let P={handleMouseenter:j,handleMouseleave:T,handleEnded:F};function j(){I.readyState>=c&&I.pause()}function T(){I.readyState>=c&&I.play()}function F(){v(I,P)}if(r){I.addEventListener("mouseenter",j),I.addEventListener("mouseleave",T);let H=t.querySelector(".ecom-video_link-extra");H&&H.href&&(H.addEventListener("mouseenter",j),H.addEventListener("mouseleave",T)),D||I.addEventListener("ended",F)}}function v(I,D){if(D){const{handleMouseenter:P,handleMouseleave:j,handleEnded:T}=D;let F=t.querySelector(".ecom-video_link-extra");I.removeEventListener("mouseenter",P),I.removeEventListener("mouseleave",j),I.removeEventListener("ended",T),F&&F.href&&(F.removeEventListener("mouseenter",P),F.removeEventListener("mouseleave",j))}}function w(I,D){I.forEach(function(P){if(P.isIntersecting){const j=P.target.querySelector("video source"),T=P.target.querySelector("video"),F=P.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){s&&T.play()})),F){let H=F.dataset.srcVideo;F.setAttribute("src",H)}D.unobserve(P.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),s&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let I=C.getAttribute("src");I.includes("autoplay=0")?I=I.replace("autoplay=0","autoplay=1"):I=I+"&autoplay=1",C.setAttribute("src",I),l?setTimeout(()=>{I=I.replace("autoplay=1","autoplay=0"),C.setAttribute("src",I)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!n&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(I){I.dataset.ecTrackingId&&I.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:I.id,tracking_id:I.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(I){if(window.EComModal)return I();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&I()});return}let D=0;const P= window.__ectimmers["ecom-0lt4rr5sdv8a"]["sg2z0oyar"] = setInterval(function(){window.EComModal?(clearInterval(P),I()):++D>=300&&clearInterval(P)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const I=x.dataset.width,D=x.dataset.height;var P=E;new window.EComModal(x,{cssClass:[P,"ecom-core","ecom-core-simulator"],onOpen:function(){var j=document.querySelector(".ecom-modal."+P);if(j){const T=j.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const F={width:I,height:D};Object.assign(T.style,F)}},onClose:function(){var j=document.querySelector(".ecom-modal."+P);if(j){const T=j.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-0lt4rr5sdv8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lt4rr5sdv8a', settings: {"autoplay":true,"player_controls":true,"source":"uploaded"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}